export class FormaDePagamento {
  id: number;
  descricao: string;
  taxa: number;
  tipo: number;
  codErp: string;
  condicoesDePagamento: number[];
  financiamento: boolean;
  financiamentoProprio: boolean;
  repasse: boolean;
  status: number;
  boleto: boolean;
  pix: boolean;
  gatewayOctopusId: string;
  actionOctopusId: string;
  fornecedores: number[];
  aderirParcelas: boolean;
  conferirPagamento: boolean;
  gerarVoucher: boolean = false;
  voucherPrazoValidade: number | null = null;
  voucherPercentual: number | null = null;
  voucherCodigo: string | null = null;
  voucherDescricao: string | null = null;
  voucherBeneficios: string | null = null;
  voucherCondicoes: string | null = null;
  voucherExcluirCupomDesconto: boolean | null = null;
}
